import React, { useMemo, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { History } from 'history'
import { Link } from 'react-router-dom'

import styles from '../component-styles/view-campaign-codes.module.scss'
import SiteWrapper from '../components/sitewrapper'
import Layout from '../components/layout'
import Intro from '../components/intro'
import Tag from '../components/tag'
import CampaignCodesTable from '../components/campaign-codes-table'
import CampaignIntroContent from '../components/campaign-intro-content'
import Stars from '../assets/star-cluster-yellow.svg'

interface Props {
  history: History
}
export default function ViewCampaignCodes({
  history,
}: Props): React.ReactElement {
  const { site } = useSelector((s: any): any => s)
  const { selected } = site

  const [dataSourceData, setDataSourceData] = useState(selected?.dataSourceData)

  useEffect((): void => {
    if (selected) {
      setDataSourceData(selected?.dataSourceData)
    }
    // eslint-disable-next-line
  }, [selected])

  const isAdobe = !!(
    site &&
    site.selected &&
    site.selected.dataSource === 'AA_REPORT'
  )

  const dataSourceTitle = useMemo(() => {
    let title = <></>
    if (dataSourceData) {
      if (Object.prototype.hasOwnProperty.call(dataSourceData, 'reportSuite')) {
        title = (
          <>
            <span>report suite:</span> <b>{dataSourceData.reportSuite}</b>.
          </>
        )
      } else if (
        Object.prototype.hasOwnProperty.call(
          dataSourceData,
          'gaPropertyName',
        ) &&
        Object.prototype.hasOwnProperty.call(dataSourceData, 'gaViewName')
      ) {
        title = (
          <>
            <span>property:</span> <b>{dataSourceData.gaPropertyName}</b>,{' '}
            <span>view:</span> <b>{dataSourceData.gaViewName}</b>.
          </>
        )
      }
    }
    return title
  }, [dataSourceData])

  return (
    <SiteWrapper noFooter>
      <Layout width={2560}>
        <Intro title="View campaign links">
          <CampaignIntroContent>
            <>
              <p>Review, share and edit campaign links.</p>
              {selected &&
              (selected.preSetup ||
                (selected.blankAccount &&
                  selected.dataSource !== 'AA_REPORT') ||
                selected.billingState === 'preSetup') ? (
                <Tag inline icon={Stars}>
                  <p>
                    <Link to="/select-module">
                      Connect your analytics platform
                    </Link>{' '}
                    to compare metrics for each campaign link.
                  </p>
                </Tag>
              ) : (
                <p className={styles.summary}>
                  {dataSourceData &&
                    isAdobe &&
                    'Metrics from Adobe Analytics, '}
                  {dataSourceData &&
                    !isAdobe &&
                    'Metrics from Google Analytics, '}
                  {dataSourceTitle}
                </p>
              )}
            </>
          </CampaignIntroContent>
        </Intro>
        <CampaignCodesTable history={history} />
      </Layout>
    </SiteWrapper>
  )
}
